import React from "react";
import {connect} from "react-redux";
import {Link} from "react-router-dom";
import {SubsidiaryUtils} from "../../../../../utils/Subsidiary/SubsidiaryUtils";
import {HallBaseConfig} from "../../../reducers/hallsList.reducer";
import "./HallRow.component.scss";
import {formatDateText} from "../../../../../utils/utils";
import {Components} from "@webtech/webtech-ui-react/build/webtech-ui";
import {AuthorizationServiceTypes} from "../../../../../utils/Authorization/authorizationTypes";
import {
    checkAuthorization,
    checkPermission
} from "./../../../../../utils/Authorization/authorization";
import {ActionCreator} from "../../../../../actions/actions";

export interface HallRowProps {
    hallInfo: HallBaseConfig;
    toggleActiveAction: ActionCreator;
}

function HallRow(props: HallRowProps) {
    const filterLicensedServers = () =>
        props.hallInfo.servers.filter(server => {
            return (
                server.license &&
                server.license.expired == false &&
                server.license.expiration != null
            );
        });

    const filterUnlicensedServers = () =>
        props.hallInfo.servers.filter(
            server =>
                !server.license ||
                server.license.expired == true ||
                server.license.expiration == null
        );

    const filterCertified = () =>
        props.hallInfo.servers.filter(
            server =>
                server.version !== null &&
                server.version > 0 &&
                server.latest_spec_version !== null &&
                server.latest_spec_version > 0 &&
                server.version === server.latest_spec_version
        );

    const hasAnyServerOnline = () =>
        !!props.hallInfo.servers.filter(
            server =>
                server.is_online
        ).length;

    const serversLicensed = filterLicensedServers();
    const serversUnlicensed = filterUnlicensedServers();
    const serversCertified = filterCertified();
    const hasLicensesAccess = checkAuthorization({
        service: AuthorizationServiceTypes.LICENSES
    });

    const serverOnline = hasAnyServerOnline()

    const style = {
        display: "flex",
        alignItems: "center"
    };

    return (
        <tr className="info-row">
            <td>
                <Link to={`/halls/${props.hallInfo.id}`}>
                    {!serverOnline && <i className="icon-wifi-slash-light"/>}
                    {serverOnline && <i className="icon-wifi-solid green"/>}
                </Link>
            </td>
            <td>
                <Link to={`/halls/${props.hallInfo.id}`}>
                    {props.hallInfo.name}
                </Link>
            </td>
            <td className="hidden-md" style={style}>
                {SubsidiaryUtils.subsidiaryIcon(props.hallInfo.subsidiary)}
                <Link to={`/halls/${props.hallInfo.id}`}>
                    {props.hallInfo.address_line_1},{" "}
                    {props.hallInfo.subsidiary.country.name}
                </Link>
            </td>
            <td className="hidden-lg">
                <Link to={`/halls/${props.hallInfo.id}`}>
                    {formatDateText(props.hallInfo.created_on, "short", true, true, true)}
                </Link>
            </td>
            <td className="hidden-xs">
                <Link to={`/halls/${props.hallInfo.id}`}>
                    {props.hallInfo.servers.length}
                </Link>
            </td>
            {hasLicensesAccess && (
                <td className="hidden-sm">
                    <Link to={`/halls/${props.hallInfo.id}`}>
                        <i
                            className={`icon-check-circle-light ${
                                serversUnlicensed.length == 0 &&
                                serversLicensed.length > 0
                                    ? "green"
                                    : ""
                            }`}
                        />
                        <span>{serversLicensed.length} Licensed</span>
                    </Link>
                </td>
            )}
            {checkPermission("spec_history") && (
                <td className="hidden-sm">
                    <Link to={`/halls/${props.hallInfo.id}`}>
                        <i
                            className={`icon-file-text ${
                                serversCertified.length > 0
                                    ? serversCertified.length ==
                                    props.hallInfo.servers.length
                                        ? "green"
                                        : "yellow"
                                    : ""
                            }`}
                        />
                        <span>{serversCertified.length} Certified</span>
                    </Link>
                </td>
            )}
            <td>
                {checkPermission("toggle_halls") && (
                    <div className="hall-status">
                        <Components.Switch
                            onClick={() =>
                                props.toggleActiveAction(props.hallInfo.id)
                            }
                            on={props.hallInfo.active}
                            enabled
                        />
                        <span>
                            {props.hallInfo.active ? "Active" : "Inactive"}
                        </span>
                    </div>
                )}
            </td>
        </tr>
    );
}

const mapStateToProps = state => ({});

export default connect(mapStateToProps, null)(HallRow);
